import { getFetchDataFunction } from '../DataTableService'
// import mdl from '../../../models/Accounting/AccAccountingSeat'

let includes = [
    'g_generator_user.hr_employee',
    'acc_accounting_seat_status',
    'acc_accounting_seat_concept',
    'acc_accounting_seat_type',
]
let route = process.env.VUE_APP_API_ROUTE + '/acc_accounting_seat'

const dtFetchData = getFetchDataFunction(route, includes, [])

export { dtFetchData }
